"use client";

import {getSignOutUrl} from "@/app/util/urlUtils";
import {usePathname, useSearchParams} from "next/navigation";

const useSignOutHref = () => {
	const pathname = usePathname();
	const query = useSearchParams();

	return getSignOutUrl(`${pathname}${query && `?${query}`}`);
};

export default useSignOutHref;
